import React from 'react';
import { createRoot } from 'react-dom/client';
import { initSentry } from '@/common/sentry';

import AppWrapper from '../app/AppWrapper';

initSentry();

// Mount function to start up the app
export const mount = () => {
    const el = document.getElementById('quality-webapp-root1');
    return createRoot(el).render(<AppWrapper />);
};

mount();
